import { selectFirst } from "@hurleymc/sdk/selectors"

export const getBlogProps = entry => {
  const contacts = entry.contact
  const author = selectFirst(contacts)
  const images = entry.images
  const image = selectFirst(images)
  return { author, image }
}
